import { keepPreviousData } from '@tanstack/react-query';
import { formatIsoDate } from '@src/shared/lib';
import { useQuery } from '@src/shared/query';
import type { UseQueryParams } from '@src/features/types';
import type { VacationBalanceDto, VacationBalances } from '../../types';
import { vacationBalanceUrl } from './constants';

export type VacationBalanceQueryParams = Partial<{
  available_until: string;
}>;

export function getVacationBalanceQueryParams({
  end,
}: {
  end: Date;
}): VacationBalanceQueryParams {
  return { available_until: formatIsoDate(end) };
}

function selectBalances(data: VacationBalanceDto[]): VacationBalances {
  const balances: VacationBalances = new Map();
  for (const item of data) {
    balances.set(item.user_id, {
      used: item.vacation_used,
      available: item.vacation_available,
    });
  }
  return balances;
}

export default function useVacationBalance(
  params: Partial<UseQueryParams> = {},
) {
  const { queryParams = {} } = params;
  const query = useQuery<VacationBalanceDto[], VacationBalances>(
    vacationBalanceUrl,
    {
      queryParams,
      select: selectBalances,
      placeholderData: keepPreviousData,
    },
  );

  const { data: balances = new Map(), ...restQuery } = query;
  return {
    balances,
    ...restQuery,
  };
}
